import * as types from '../constants';

const initialServiceWorkerState = {
   serviceWorkerInitialized: false,
   serviceWorkerUpdated: false,
   serviceWorkerRegistration: null,
};

function serviceWorkerReducer(state = initialServiceWorkerState, action) {
   switch (action.type) {
      case types.SERVICE_WORKER_INIT:
         return {
            ...state,
            serviceWorkerInitialized: !state.serviceWorkerInitialized,
         };
      case types.SERVICE_WORKER_UPDATE:
         return {
            ...state,
            serviceWorkerUpdated: true,
            serviceWorkerRegistration: action.payload,
         };
      default:
         return state;
   }
}

export default serviceWorkerReducer;
